/**
 *
 * @module errorReason
 *
 */

/**
 *
 * @class ErrorReason
 * @desc information regarding exception
 *
 */
export default class ErrorReason {

    /**
     *
     * @param {String} code - Reason code. Can be used by the application developer to look up localized error messages.
     * @param {String} [description=''] - Additional error information (optional).
     *
     */
    constructor(code, description = '') {

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.code = code;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.description = description;

    }

}



// WEBPACK FOOTER //
// ./src/services/exception/errorReason.js